var changePwSuccess = function(o) {
	// Parsing JSON strings can throw a SyntaxError exception, so we wrap the
	// call
	// in a try catch block
	try {
		var formResponse = YAHOO.lang.JSON.parse(o.responseText);
		if (formResponse['RESULT'] != "OK") {
			if (formResponse['RESULT'] == "SYSTEM_ERROR") {
				window.top.showSystemError(formResponse['ERROR_HEADER'],
					formResponse['ERROR'], formResponse['BUTTON_TEXT']);
				return;
			}
			var form = document.getElementById('changepasswordform1');
			var did;
			try {
				did = getDid();
			} catch (e) {
				did = window.top.getDid();
			}
			form.elements[form.elements.length - 1].value = did;
			var errorString = "<ul>";
			for (var i = 0; i < form.elements.length; i++) {
				var element = form.elements[i];
				if (formResponse['ERROR_FIELDS'].indexOf(element.name) != -1
					&& formResponse[element.name] != null) {
					showSymbol(element.name, "fieldstatus-error");
					errorString = errorString + "<li>"
						+ formResponse[element.name] + "</li>";
				} else {
					showSymbol(element.name, "fieldstatus-info");
				}
			}
			errorString = errorString + "<ul/>";
			window.top.showInfoMessage(formResponse['ERROR_HEADER'],
				errorString, formResponse['BUTTON_TEXT'], true, null, null,
				window.top.validationErrorHeader);
		} else {
			// Everything went alright
			var form = document.getElementById('changepasswordform1');
			for (var i = 0; i < form.elements.length; i++) {
				var element = form.elements[i];
				if (element.type == 'text' || element.type == 'password') {
					element.value = "";
				}
				showSymbol(element.name, "fieldstatus-info");
			}
			var did;
			try {
				did = getDid();
			} catch (e) {
				did = window.top.getDid();
			}
			form.elements[form.elements.length - 1].value = did;
			window.top.showInfoMessage(formResponse['IN_HEADER'],
				formResponse['TEXT'], formResponse['BUTTON_TEXT'], true,
				null, null, formResponse['HEADER']);
		}
	} catch (e) {
		window.top.showSystemError('System error',
			'An unexpected system error occured in changePwSuccess' + e,
			'OK');
	}
};

var changePwFailure = function(o) {
	showSystemError('System error', 'An unexpected system error occured', 'OK');
};

var changePwCallback = {
	success: changePwSuccess,
	failure: changePwFailure,
	cache: false
};

function submitChangePw() {
	var cpform = document.getElementById('changepasswordform1');
	var did;
	try {
		did = getDid();
	} catch (e) {
		did = window.top.getDid();
	}

	cpform.elements[cpform.elements.length - 1].value = did;
	var cpformAction = cpform.getAttribute('action');
	var formdata = YAHOO.util.Connect.setForm(cpform);
	YAHOO.util.Connect.initHeader('Content-Type',
		'application/x-www-form-urlencoded; charset=UTF-8');
	var transaction = YAHOO.util.Connect.asyncRequest('POST', cpformAction,
		changePwCallback);
}

function pwHideModalPanel() {
	simpleLogout();
	if (modalPanel) {
		modalPanel.hide();
		modalPanel.destroy();
		modalPanel = null;
	}
}

function simpleLogout() {
	var callback = {
		success: function(o) {

		},
		failure: function(o) {
		},
		cache: false
	};
	YAHOO.util.Connect.asyncRequest('POST', '/pp', callback, 'flow=LogoutPlayer');
}

var forgotPwResponseSuccess = function(o) {
	// Parsing JSON strings can throw a SyntaxError exception, so we wrap the
	// call
	// in a try catch block
	try {
		var formResponse = YAHOO.lang.JSON.parse(o.responseText);
		if (formResponse['RESULT'] != "OK") {
			if (formResponse['RESULT'] == "SYSTEM_ERROR") {
				pwHideModalPanel();
				showSystemError(formResponse['ERROR_HEADER'],
					formResponse['ERROR'], formResponse['BUTTON_TEXT']);
				return;
			}
			var el = new YAHOO.util.Element(modalPanel.body);
			var inputObjects = el.getElementsByTagName("input");
			for (var i = 0; i < inputObjects.length; i++) {
				var input = new YAHOO.util.Element(inputObjects[i]);
				if (input.get("name") == formResponse['ERROR_FIELDS']) {
					input.replaceClass("comeon", "comeonError");
				}
			}
			showInfoMessage(formResponse['ERROR_HEADER'],
				formResponse['ERROR'], formResponse['BUTTON_TEXT'], true,
				null, null, window.top.pwValidationErrorPanelHeader);
		} else {
			// Everything went alright in a matter of speaking

			// Check the code to see what the next step is
			if (formResponse['CODE'] == "REG_UNVERIFIED_EMAIL") {
				pwHideModalPanel();
				getModalPanelHtml("forgotpwemailver", window.top.panelPwHeader2);
			} else if (formResponse['CODE'] == "TEMP_PASSWORD_SENT_EMAIL"
				|| formResponse['CODE'] == "TEMP_PASSWORD_SENT_SMS"
				|| formResponse['CODE'] == "EMAIL_VER_SENT") {
				pwHideModalPanel();
				window.top.showInfoMessage("", formResponse['TEXT'],
					formResponse['BUTTON_TEXT'], true, null, null,
					window.top.panelPwHeader3);

			} else if (formResponse['CODE'] == "REG_DEPOSIT_WITHDRAW") {
				pwHideModalPanel();
				getModalPanelHtml("forgotpw2", window.top.fgpwmHeader);
			}
		}
	} catch (e) {
		modalPanel.hide();
		showSystemError(
			'System error',
			'An unexpected system error occured in forgotPwResponseSuccess',
			'OK');
	}
};

var forgotPwResponseFailure = function(o) {
	showSystemError('System error',
		'An unexpected system error occured in forgotPwResponseFailure',
		'OK');
};

var forgotPwCallback = {
	success: forgotPwResponseSuccess,
	failure: forgotPwResponseFailure,
	cache: false
};

function changePw() {
	getModalPanelHtml('ChangePwForm', window.top.panelChangePwHeader);
	setTimeout(function() {
		$(".container-close").click(function() {
			simpleLogout();
		});
	}, 3000);
}

function forgotPw1() {
	dialog.close('login');
	getModalPanelHtml('InitForgotPassword', window.top.panelPwHeader3);
}

function submitForgotPw() {
	var el = new YAHOO.util.Element(modalPanel.body);
	var formObject = el.getElementsByTagName("form")[0];
	var formAction = el.getElementsByTagName("form")[0].getAttribute('action');

	if (formObject.elements[3] != null) {
		var tmp = document.getElementById("PARAM_MOBILE_PHONE").value;
		formObject.elements[3].value = formObject.elements[2].value
			+ formObject.elements[3].value;

	}
	//
	var formdata = YAHOO.util.Connect.setForm(formObject);
	YAHOO.util.Connect.initHeader('Content-Type',
		'application/x-www-form-urlencoded; charset=UTF-8');
	var transaction = YAHOO.util.Connect.asyncRequest('POST', formAction,
		forgotPwCallback);
	var u = document.getElementById("PARAM_MOBILE_PHONE");
	if (tmp != null) {
		u.value = tmp;
	}
}

function changePwEmailCode() {
	var x = document.getElementById("pwformemailcode");
	window.top.showModalPanel("crrr", x.innerHTML, window.top.location, null,
		null, true, true);
}

function changePwSmsCode() {
	var x = document.getElementById("pwformsmscode");
	window.top.showModalPanel("drrr", x.innerHTML, window.top.location, null,
		null, true, true);
}

function emailCode() {
	var x = document.getElementById("emailcode");
	window.top.showModalPanel("errr", x.innerHTML, window.top.location, null,
		null, true, true);
}

function smsCode() {
	var x = document.getElementById("smscode");
	window.top.showModalPanel("frrr", x.innerHTML, window.top.location, null,
		null, true, true);
}

function pwStrength(inPw) {
	var strength = 1;
	var length = 1;
	var letters = 1;
	var numbers = 1;
	var specChars = 1;
	var combos = 1;

	// Length
	if (inPw.length > 11) {
		length = 3;
	} else if (inPw.length > 7) {
		length = 2;
	}
	// letters
	var lowerCase = false;
	var upperCase = false;
	var s = inPw;
	for (var i = 0; i < s.length; i++) {
		if (s.charCodeAt(i) > 96 && s.charCodeAt(i) < 123) {
			lowerCase = true;
		} else if (s.charCodeAt(i) > 64 && s.charCodeAt(i) < 91) {
			upperCase = true;
		}
	}
	if (lowerCase && upperCase) {
		letters = 3;
	} else if (lowerCase || upperCase) {
		letters = 2;
	}
	// Numbers
	for (i = 0; i < s.length; i++) {
		if (s.charCodeAt(i) > 47 && s.charCodeAt(i) < 58 && numbers < 3) {
			numbers++;
		}
	}
	// Special characters
	for (i = 0; i < s.length; i++) {
		if (((s.charCodeAt(i) > 32 && s.charCodeAt(i) < 48)
			|| (s.charCodeAt(i) > 57 && s.charCodeAt(i) < 65)
			|| (s.charCodeAt(i) > 90 && s.charCodeAt(i) < 97) || (s
			.charCodeAt(i) > 122 && s.charCodeAt(i) < 127))
			&& specChars < 3) {
			specChars++;
		}
	}
	if (letters > 1 && numbers > 1 && specChars > 1) {
		combos = 3;
	} else if ((letters > 1 && numbers > 1) || (numbers > 1 && specChars > 1)
		|| (specChars > 1 && letters > 1)) {
		combos = 2;
	}

	strength = Math
		.round((length + letters + numbers + specChars + combos) / 5);
	return strength;
}
;
define("legacy/pw", function(){});

